<template>
  <div id="HeaderBottom">
    <!-- <img @click.prevent="goToRoute('Home')" src="@/assets/logo.png" class="logo"/> -->
  <div class="main-nav">
    <ul class="nav-list">

      <li
        v-for="(item, id) in menuFiltered"
        :key="id" class="nav-i"
        :class="{'slit-line': menuFiltered.length <= 2 && id == 0, 'main-add': item.name == 'AddPet'}"
        @click.prevent="goToRoute(item.route, id)">
        <img  :src="item.icon" />
        <!-- <XyzTransition class="item-group" xyz="narrow-5 big-5" v-if="selected_menu == id">
          <img v-if="selected_menu == id" :src="item.icon" />
        </XyzTransition> -->
        </li>
    </ul>
  </div>

  </div>
</template>
<script>
// import {db} from '@/_firebase/init'
import {mapGetters, mapMutations, mapState} from 'vuex'
// import ClipLoader from 'vue-spinner/src/ClipLoader.vue'

export default{
  // components:{
  //   'vue-spinner': ClipLoader
  // },
  data(){
    return{
      investor_since: 'Sep 2020',
      processing: false,
      showSideMenu: false,
      selected_menu: -1,
      imgBrightness:{
        filter: 'brightness(1)'
      },
      menuList:[
        {icon: require('@/assets/svg/bottom_menu/home2.svg'),
        name: 'Home', route:'OnboardingMain'},
        {icon: require('@/assets/svg/bottom_menu/user2.svg'),
        name: 'Account', route:'PetProfileMenu'},
      ],
      userdata:{
        photo:'',
        username: '',
        fname: '',
        lname: '',
        profile_stats:{
          subscribers: 0
        }

      }
    }
  },
  methods:{
    currentRoute(item){
        return item.icon
    },
    goToRoute(route, id){
      const route_username = this.$route.params.username
      this.selected_menu = id
      console.log(id)
      if(route == 'PetProfileMenu' && !this.isAuthenthicated){
        this.$router.push({name: 'GateLogin'})
      }else if(route == 'PetProfileMenu' && this.isAuthenthicated){
        window.open('/menu', '_self')
      }else if(route == 'PetProfile' && !this.isAuthenthicated){
        window.open(`/u/${route_username}`, '_self')
        // this.$router.push({name: 'ScannedProfile', params:{username: route_username}})
        // this.$router.push({name: 'GateLogin'})
      }else if(route == 'AddAPet'){
        this.REMOVE_NEW_SCANED_TAG()
        this.$router.push({name: route})
      }else{
        this.$router.push({name: route})
      }
    },
    togggleTheme(){
      if(this.theme == 'light'){
        this.imgBrightness = {
          filter: 'invert(1)'
        }
        this.SET_THEME('dark')
      }else{
        this.SET_THEME('light')
      }
    },
    // getData(){
    //   let userRef = db.collection('asapleads_users').doc(`${this.userID}`);
    //   let getDoc = userRef.get()
    //     .then(doc => {
    //       if (!doc.exists) {
    //         this.feedback = 'No such document!'
    //         console.log('No such document!');
    //       } else {
    //         this.userdata = doc.data()
    //       }
    //     })
    //     .catch(err => {
    //       console.log('Error getting document', err);
    //     });
    // },
    ...mapMutations([
      'SET_THEME', 'REMOVE_NEW_SCANED_TAG'
    ]),
  },
  computed:{
    ...mapGetters([
      'isAuthenthicated'
    ]),
    ...mapState(['theme', 'userID', 'role']),
    menuFiltered(){
      let filtered_menu = this.menuList
      if(!this.isAuthenthicated){
        filtered_menu = this.menuList.filter((value) => {
           return value.name == 'Home'
       });
       filtered_menu.push({icon: require('@/assets/svg/bottom_menu/list.svg'),
         name: 'RedirectTree', route:'RedirectTree'},)
      }
     return filtered_menu
    }
  },
  created(){
  }
}
</script>
<style scoped>
#HeaderBottom{
  background-color: #fff;
  width: 100%;
  position: relative;
}
.main-nav{
  bottom: 0;
  height: 3.5rem;
  width: 100%;
  margin: 0;
  padding:0;
  position: fixed;
  background: rgba(219,219,219);
  z-index: 60;
  transition: width .3s ease;
  background-color: #fff;
  background-position: center;
  background-repeat: no-repeat;
  background-size: 200%;
  text-align: center;
  transition: 1s;
  -webkit-box-shadow: -2px -36px 38px 14px rgba(219,219,219,.5);
  -moz-box-shadow: -2px -36px 38px 14px rgba(219,219,219,.5);
  box-shadow: -2px -36px 38px 14px rgba(219,219,219,.5);
}
.nav-list{
  margin: 0;
  height: 4rem;
  padding:0;
  display: flex;
  list-style-type: none;
  min-width: 30%;
  transition: 1s;
}
.nav-i{
  color: #000;
  transition: .6s;
  text-decoration: none;
  cursor: pointer;
  width: 100%;
  margin: 0;
  transition: 1s;
  display: flex;
  align-items: center;
  text-decoration: none;
  height: 4rem;
  justify-content: center;
}
.slit-line{
  border-right: 1px solid #fff;
}
.hide{display: none;}
.logo{
  display:none;
}
.bottomnav{
  display: block;
  z-index: 10 !important;
  height: 3.4rem;
  top: 0;
  left: 0;
}
.nonMobile{
  display: none;
}
.nav-list {
  list-style: none;
  padding: 0;
  margin: 0;
  width: 100vw;
  display: flex;
  flex-direction: row;
  align-items: center;
  height: 100%;
}
.link-text{
  display: none;
  margin-left: 1rem;
}
.nav-i img{
  /* position: absolute; */
  min-width: 2rem;
  width: 3rem;
  margin: 0;
  transition:1s;
}
.main-add img{
  width: 6rem;
  position: absolute;
  margin-top: -1rem;
  transition:1s;
}
body[data-theme='dark']  #HeaderBottom,
body[data-theme='dark'] .main-nav{
  background-color: #111;
}

@media only screen and (max-width: 600px) {
  .nav-i img{
    width: 1.6rem;
  }
  .main-add img{
    width: 4rem;
    margin-top: 0;
  }
}
</style>
